// Components==============
import Button from 'components/UI/Button/Button';
import { usePermission } from 'hooks/usePermission';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import { DeleteModalContext } from '../../DeleteModal';
import './Buttons.module.scss';
// =========================

export default function Buttons() {
  const translate = useTranslate();

  const {
    handleDelete,
    handleOwnerTransfer,
    deleteCondition,
    handleLeaveGroup,
  } = useContext(ProjectDetailsContext);

  const {
    setModalIsOpen,
    shouldTransfer,
    transferUser,
    processIsChecked,
    themeIsChecked,
    selectedUsers,
    userSelectedSelf,
    userShouldLeaveGroup,
  } = useContext(DeleteModalContext);

  const isTeacher = usePermission(['Docent', 'super-admin']);

  function handleClick() {
    setModalIsOpen(false);

    // handle transfer
    if (shouldTransfer && transferUser)
      return handleOwnerTransfer(transferUser.id);

    // handle leave
    if (userShouldLeaveGroup) return handleLeaveGroup();

    // handle delete
    handleDelete({
      processIsChecked,
      themeIsChecked,
      selectedUsers: selectedUsers.map((u) => u.memberId),
      historyPush: userSelectedSelf,
    });
  }

  const canLeaveWithoutAction = userShouldLeaveGroup && !shouldTransfer;

  const inactiveCondition = canLeaveWithoutAction
    ? false
    : (isTeacher ? selectedUsers.length === 0 : true) &&
      (shouldTransfer ? !transferUser : true) &&
      !themeIsChecked &&
      !processIsChecked;

  return (
    <div styleName="wrapper">
      <Button color="grey" onClick={() => setModalIsOpen(false)}>
        {translate('general.terms.cancel')}{' '}
      </Button>
      <Button color="red" inactive={inactiveCondition} onClick={handleClick}>
        {shouldTransfer
          ? translate(
              'project.groupswork-popups.delete-popup.delete-and-transfer'
            )
          : deleteCondition
          ? translate(`general.terms.delete`)
          : translate(
              `general.terms.leave${
                processIsChecked || themeIsChecked ? '-and-delete' : ''
              }`
            )}
      </Button>
    </div>
  );
}
